import * as React from "react";
import { OddsUpdateIndicator } from "../OddsUpdateIndicator";
import { handleOddsAnimationEnd, handleOddsUpdateAnimation, getPrePacksPrefix, shallowPrimitiveCompare } from "../helpers";
import { LockIcon } from "../LockIcon";
export const oddsUpdateIndicatorClass = "rj-prepack-odds-update-indicator";
export class PrePack extends React.Component {
    constructor() {
        super(...arguments);
        this.buttonRef = React.createRef();
        this.baseClassName = getPrePacksPrefix("prePack");
        this.animId = 0;
        this.handleOnClick = () => this.props.onClick(this.props.id, this.props.toggleModifier);
        this.handleAnimationEnd = () => handleOddsAnimationEnd(this.buttonRef.current);
        this.onOddsUpdate = () => handleOddsUpdateAnimation(this.buttonRef.current);
    }
    componentDidMount() {
        if (this.shouldTriggerUnlockAnimation()) {
            this.onOddsUpdate();
            this.props.onUnlockAnimationTriggered();
        }
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isLocked && this.props.isLocked) {
            this.props.onPrePackLocked();
        }
        if (prevProps.isLocked && !this.props.isLocked) {
            this.props.onUnlockAnimationTriggered();
        }
    }
    componentWillUnmount() {
        cancelAnimationFrame(this.animId);
    }
    shouldTriggerUnlockAnimation() {
        return !this.props.isInitialPull && !this.props.isLocked && this.props.shouldTriggerUnlockAnimation();
    }
    shouldComponentUpdate(nextProps) {
        if (this.props.isLocked !== nextProps.isLocked && !nextProps.isLocked) {
            cancelAnimationFrame(this.animId);
            this.animId = requestAnimationFrame(this.onOddsUpdate);
            return true;
        }
        return shallowPrimitiveCompare(nextProps, this.props);
    }
    render() {
        const { children, toggleModifier, americanOdds, displayOdds, isLocked, isSuspended } = this.props;
        return (React.createElement("li", { className: this.baseClassName, "data-testid": "wrapper-prepack" },
            React.createElement("div", { className: `${this.baseClassName}__selections` }, children),
            React.createElement("button", { type: "button", "data-testid": "button-prepack-toggle", ref: this.buttonRef, className: `${this.baseClassName}__toggle ${this.baseClassName}__toggle--${toggleModifier}`, "aria-pressed": toggleModifier === "selected", onClick: this.handleOnClick, onAnimationEnd: this.handleAnimationEnd, disabled: isSuspended || isLocked },
                React.createElement(OddsUpdateIndicator, { trueOdds: americanOdds, onOddsUpdate: this.onOddsUpdate }),
                toggleModifier === "loading" && React.createElement("div", { className: `${this.baseClassName}__toggle-animate-loading` }),
                isLocked ? React.createElement(LockIcon, null) : React.createElement("span", { className: `${this.baseClassName}__toggle-odds` }, displayOdds))));
    }
}
//# sourceMappingURL=PrePack.js.map